<!-- src/views/CustomAvatar.vue -->
<template>
  <div class="generate-result-page">
    <!-- 导航栏 -->
    <div class="custom-nav-bar" v-if="currentPlatform !== 'weixin'">
      <div class="back-btn" @click="onBack">
        <img src="@/assets/back.svg" class="back-icon" />
      </div>
      <div class="nav-title">形象定制</div>
    </div>

    <div class="page-body">
      <div class="bodayTitle">样例视频</div>
      <div class="bodyTop" @click="goVideo('1')">
        <img :src="spfm1" alt="" class="video" v-if="spfm1" />
        <img
          src="@/assets/aiVideo/sampleGraph6.png"
          alt="#"
          class="video"
          v-else
        />
        <img src="@/assets/aiVideo/sybf.png" alt="#" class="bodyTop-sybf" />
      </div>

      <div class="bodayTitle">上传视频</div>
      <div class="uploadList">
        <div class="uploadListItem" @click="goPage('recordingGuide')">
          <div class="uploadListItemTitle">
            <div>{{ havSp ? "训练视频" : "第一步" }}</div>
            <img
              src="@/assets/aiVideo/writeDelete.svg"
              alt="#"
              v-if="havSp"
              @click.stop="deleteSomthing('1')"
            />
          </div>
          <div class="uploadListItemImg" v-if="!havSp">
            <img
              src="@/assets/aiVideo/add.png"
              alt="#"
              class="uploadListItemImg_img"
            />
          </div>
          <div class="uploadListItemMessage" v-if="!havSp">
            上传2K/4K视频后续可制作同清晰度高清视频
          </div>
          <img
            src="@/assets/aiVideo/sybf.png"
            alt="#"
            class="bodyTop-sybf"
            v-if="havSp"
          />
          <img :src="spfm2" alt="#" v-if="havSp" class="spdiz" />
        </div>
        <div class="uploadListItem" @click="goPage('authorizedVideo')">
          <div class="uploadListItemTitle">
            <div>{{ haveSqSp ? "授权视频" : "第二步" }}</div>
            <img
              src="@/assets/aiVideo/writeDelete.svg"
              alt="#"
              v-if="haveSqSp"
              @click.stop="deleteSomthing('2')"
            />
          </div>
          <div class="uploadListItemImg" v-if="!haveSqSp">
            <img
              src="@/assets/aiVideo/add.png"
              alt="#"
              class="uploadListItemImg_img"
            />
          </div>
          <div class="uploadListItemMessage" v-if="!haveSqSp">授权视频</div>
          <img
            src="@/assets/aiVideo/sybf.png"
            alt="#"
            class="bodyTop-sybf"
            v-if="haveSqSp"
          />
          <img :src="spfm3" alt="#" v-if="haveSqSp" class="spdiz" />
        </div>
      </div>

      <div class="bodayTitle" v-if="voiceCount < 3">上传音频</div>

      <!-- ✅ 渲染多个 VoiceItem，并绑定动态 ref -->
      <div v-if="voiceList.length > 0 && voiceCount < 3">
        <VoiceItem
          v-for="voice in voiceList"
          :key="voice.id"
          :voice="voice"
          :ref="`voiceItem_${voice.id}`"
          @request-play="handleRequestPlay"
          @delete="handleDeleteVoice"
          @play-error="handlePlayError"
        />
      </div>

      <!-- 无音频时显示添加提示 -->
      <div
        class="voiceDiv"
        @click="goPage('customVoice')"
        v-if="voiceCount < 3 && voiceList.length < 1"
      >
        <img
          src="@/assets/aiVideo/add.png"
          alt="#"
          class="uploadListItemImg_img"
        />
        <div class="voiceDivMessage">请录制您的专属声音</div>
      </div>

      <div class="ok">
        <div
          class="okBtn"
          :class="submitType ? 'okBtnClick' : ''"
          @click="submit"
        >
          完成
        </div>
      </div>
    </div>

    <FullScreenVideo
      :src="videoSrc"
      @error="handleVideoError"
      @goBack="goBack"
      v-if="showVideo"
    />
  </div>
</template>

<script>
import FullScreenVideo from "@/components/fullScreenVideo.vue";
import VoiceItem from "@/components/voiceItem.vue";
import {
  deviceEnv
} from '@/utils/device.js';
import {
  queryVoUploadInfo,
  voDelete,
  createFile,
  addAvatar,
  queryVoCount,
} from "@/api";
export default {
  name: "CustomAvatar",
  components: {
    FullScreenVideo,
    VoiceItem,
  },
  data() {
    return {
      clickType: false,
      havSp: false,
      haveSqSp: false,
      showVideo: false,
      spfm1:
        "https://newtouch-aihuman-dat.oss-cn-beijing.aliyuncs.com/newTouch/uploads/20260206/05a6e3c7ce464b99.jpg",
      spUrl1:
        "https://newtouch-aihuman-dat.oss-cn-beijing.aliyuncs.com/newTouch/uploads/20260206/a8b1c5f003614c73.mp4",
      spfm2: "",
      spUrl2: "",
      spfm3: "",
      spUrl3: "",
      videoSrc: "",
      voiceList: [],
      currentPlayingVoice: null,
      dataList: [],
      videoTime: "",
      voiceCount: "",
	  currentPlatform: '',
    };
  },
  computed: {
    submitType() {
      return (
        this.havSp &&
        this.haveSqSp &&
        (this.voiceList.length > 0 || this.voiceCount > 2)
      );
    },
  },
  async mounted() {
	  document.title = "形象定制";
	  this.currentPlatform = sessionStorage.getItem('h5_uni_platform');
    sessionStorage.setItem('goPage','') 
    this.haveHistoryList();
    this.haveQueryVoCount();
    this.showChange()
  },
  methods: {
    async haveQueryVoCount() {
      let data = await queryVoCount();
      this.voiceCount = data.voiceCount;
    },
    showChange(){
      document.addEventListener("visibilitychange", function() {
        if (!document.hidden) {
          // 页面回到前台（相当于小程序的 onShow）          
          // 1. 检查是否需要刷新（比如检查一个标志位）
          if (window.needRefreshVideoList) {
            this.haveHistoryList(); // 调用你的获取视频列表函数
            window.needRefreshVideoList = false; // 重置标志位
          }
        }
      })
    },
    async haveHistoryList() {
      this.havSp = false;
      this.spfm2 = "";
      this.spUrl2 = "";
      this.haveSqSp = false;
      this.spfm3 = "";
      this.spUrl3 = "";
      this.videoTime = "";
      let data = await queryVoUploadInfo({ spot: "1" });
      this.dataList = data;
      let list1 = data.filter((e) => e.audioType == 1);
      if (list1.length > 0) {
        this.havSp = true;
        this.spfm2 = list1[0].fileImageUrl;
        this.spUrl2 = list1[0].fileUrl.split("?")[0];
        this.videoTime = list1[0].videoTime;
      }
      let list2 = data.filter((e) => e.audioType == 2);
      if (list2.length > 0) {
        this.haveSqSp = true;
        this.spfm3 = list2[0].fileImageUrl;
        this.spUrl3 = list2[0].fileUrl.split("?")[0];
      }
      this.voiceList = data
        .filter((e) => e.audioType == 3)
        .map((e) => {
          return {
            ...e,
            name: "我的专属声音",
            url: e.fileUrl.split("?")[0],
            copyStatus: 2,
          };
        });
    },
    async onBack() {
      this.pauseAllVoices(); // 返回前暂停所有
      if (sessionStorage.getItem("formPage")) {
        this.$router.push({
          path: sessionStorage.getItem("formPage")
            ? sessionStorage.getItem("formPage")
            : "myFigure",
        });
      } else {
        this.$router.go(-1);
      }
    },

    goBack() {
      this.showVideo = false;
    },

    async goVideo(type) {
      if (type == 1) {
        this.videoSrc = this.spUrl1;
      } else if (type == 2) {
        this.videoSrc = this.spUrl2;
      } else {
        this.videoSrc = this.spUrl3;
      }
      this.showVideo = true;
      this.pauseAllVoices();
    },

    async goPage(path) {
      if (path === "recordingGuide" && this.havSp) return this.goVideo("2");
      if (path === "authorizedVideo" && this.haveSqSp) return this.goVideo("3");
      this.$router.push({ path, query: { formPath: "customAvatar" } });
    },

    handleVideoError(error) {
      console.log(error);
    },
    // ✅ 主动暂停所有音频
    pauseAllVoices() {
      for (const voice of this.voiceList) {
        const refName = `voiceItem_${voice.id}`;
        const instances = this.$refs[refName];
        if (instances && Array.isArray(instances) && instances[0]) {
          instances[0].pause(); // v-for 中的 ref 是数组
        }
      }
      this.currentPlayingVoice = null;
    },
    // 协调播放：确保只有一个在播
    handleRequestPlay(voiceComponent) {
      if (
        this.currentPlayingVoice &&
        this.currentPlayingVoice !== voiceComponent
      ) {
        this.currentPlayingVoice.pause();
      }
      this.currentPlayingVoice = voiceComponent;
    },

    handleDeleteVoice(voice) {
      this.deleteSomthing("3");
    },

    handlePlayError(error) {
      this.$toast && this.$toast("音频播放失败，请检查网络或浏览器权限");
    },
    async deleteSomthing(type) {
      let id = this.dataList.filter((e) => e.audioType == type)[0].id;
      await voDelete(id);
      this.haveHistoryList();
      if(type=='1'){
        sessionStorage.setItem('goPage',true) 
      }
    },
    async submit() {
      if (!this.submitType) return;
      if (this.voiceCount > 2) {
        await addAvatar({
          sampleUrl: this.spUrl2,
          fileImageUrl: this.spfm2,
          authUrl: this.spUrl3,
          videoTime: this.videoTime,
          soundId: null,
        });
        // this.$router.go(-1)
        this.$router.push({
          path: sessionStorage.getItem("formPage")
            ? sessionStorage.getItem("formPage")
            : "myFigure",
        });
      } else {
        let params = {
          voiceUrl: this.voiceList[0].url,
          voiceTime: this.voiceList[0].videoTime,
        };
        let data = await createFile(params);
        await addAvatar({
          sampleUrl: this.spUrl2,
          fileImageUrl: this.spfm2,
          authUrl: this.spUrl3,
          videoTime: this.videoTime,
          soundId: data.soundId,
        });
        this.$router.go(-1);

        // this.$router.push({
        //   path: sessionStorage.getItem("formPage")
        //     ? sessionStorage.getItem("formPage")
        //     : "myFigure",
        // });
      }
    },
  },

  beforeDestroy() {
    this.pauseAllVoices(); // 页面销毁前清理
  },
};
</script>

<style scoped>
/* ========== 保留你原有的全部样式 ========== */
.generate-result-page {
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

.custom-nav-bar {
  width: 100%;
  height: 11.7333vw;
  background-image: linear-gradient(90deg, #e7f2fa 0%, #dbe2f1 100%);
  box-shadow: 0px 0.1333vw 0px 0px rgba(97, 182, 255, 0.3);
  position: relative;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  flex-shrink: 0;
}

.back-btn {
  width: 6.4vw;
  height: 6.4vw;
  position: absolute;
  left: 2.6667vw;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.nav-title {
  font-family: SourceHanSansSC-Medium;
  font-size: 4.8vw;
  color: #000000;
  letter-spacing: 0.1333vw;
  text-align: center;
  line-height: 11.7333vw;
  font-weight: 500;
}

.page-body {
  overflow-y: auto;
  padding: 5.333vw 4.2666vw 20vw 4.2666vw;
}

.bodayTitle {
  height: 6.2666vw;
  color: #1f2226;
  font-weight: 700;
  font-size: 4.2666vw;
  text-align: left;
  line-height: 6.2666vw;
  opacity: 0.9;
  padding-bottom: 2.133vw;
  border-bottom: 0.2666vw solid #e4e8ec;
}

.video {
  width: 86.133vw;
  margin-top: 3.2vw;
  margin-bottom: 5.333vw;
  height: 42.666vw;
  margin-left: 2.666vw;
  margin-right: 2.666vw;
  border-radius: 2.1333vw;
}

.uploadList {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3.2vw 4vw 0 4vw;
  margin-bottom: 5.333vw;
}

.uploadListItem {
  display: block;
  width: 38.4vw;
  height: 45.333vw;
  border-radius: 1.6vw;
  background-color: #f0f4f8;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
  position: relative;
}

.uploadListItemTitle {
  background-color: #2a7cee;
  border-top-left-radius: 1.6vw;
  border-top-right-radius: 1.6vw;
  padding-left: 2.133vw;
  padding-right: 2.1333vw;
  height: 4.8vw;
  line-height: 4.8vw;
  color: #ffffff;
  font-weight: 400;
  font-size: 2.666vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.uploadListItemTitle > img {
  width: 3.2vw;
  height: 3.2vw;
}

.uploadListItemImg {
  margin: 10.1333vw 0 5.8666vw 0;
  display: flex;
  justify-content: center;
}

.uploadListItemImg_img {
  width: 8vw;
  height: 8vw;
}

.uploadListItemMessage {
  padding: 0 3.2vw 0 3.2vw;
  text-align: center;
  color: #9ca0a3;
  font-weight: 400;
  font-size: 3.2vw;
  line-height: 4.8vw;
}

.voiceDiv {
  margin-top: 3.2vw;
  margin-bottom: 8vw;
  background-color: #f0f4f8;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
  height: 37.333vw;
  margin-left: 2.666vw;
  margin-right: 2.666vw;
  border-radius: 1.6vw;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
}

.voiceDivMessage {
  color: #9ca0a3;
  font-weight: 400;
  font-size: 3.2vw;
  line-height: 4.8vw;
  margin-top: 3.2vw;
}

.ok {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 7.6vw;
  padding-top: 8vw;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  background: #ffffff;
}

.okBtn {
  width: 53.333vw;
  height: 8vw;
  border-radius: 2.1333vw;
  background-color: #ebebed;
  text-align: center;
  line-height: 8vw;
  color: #666666;
  font-weight: 500;
  font-size: 3.2vw;
}

.okBtnClick {
  background: linear-gradient(
    148.76deg,
    rgba(47, 255, 181, 1) 0%,
    rgba(30, 137, 255, 1) 100%
  ) !important;
  color: #ffffff !important;
}

.yyyp {
  background-color: #d2dae4;
  box-shadow: 0px 0px 0.5333vw 0px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 13.333vw;
  margin-top: 3.2vw;
  margin-left: 2.666vw;
  margin-right: 2.666vw;
  border-radius: 1.6vw;
  padding: 0 4.8vw 0 4.2666vw;
  margin-bottom: 18.8vw;
}

.yyyp > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.deleteImg {
  width: 4.2666vw;
  height: 4.2666vw;
}

.sybf {
  width: 5.333vw;
  height: 5.333vw;
  margin-right: 3.2vw;
}

.syTitle {
  line-height: 4.8vw;
  font-size: 3.2vw;
  color: #1f2226;
  text-align: center;
  font-weight: 400;
}

.spdiz {
  width: 38.4vw;
  height: 40.5333vw;
  object-fit: cover;
}

.bodyTop {
  position: relative;
}

.bodyTop-sybf {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8vw;
  height: 8vw;
}
</style>
